export class QuantiteDossierSuiviPortefeuilleRisqueDTO {
         nombreCreanceSaines: number;
         nombreCreanceImpayees: number;
         nombreDeclassement: number;
         nombreCreanceDeclarees: number;
       }